(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dg-animated-stats"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dg-count-stats')) {
 customElements.define('dg-count-stats', class extends HTMLElement {
  connectedCallback() {
   if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
   this.observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.animate(); }
   }, { threshold: 0.25 });
   this.observer.observe(this);
  }
  animate() {
   const nodes = [...this.querySelectorAll('[data-count]')].map(node => ({ node, raw: node.dataset.count.trim(), value: Number(node.dataset.count), decimals: Math.min(3, (node.dataset.count.split('.')[1] || '').length) })).filter(item => Number.isFinite(item.value));
   const duration = Number(this.dataset.duration) || 1600;
   const start = performance.now();
   const tick = now => {
    const progress = Math.min(1, (now - start) / duration);
    const eased = 1 - Math.pow(1 - progress, 3);
    nodes.forEach(item => { item.node.textContent = progress === 1 ? item.raw : (item.value * eased).toFixed(item.decimals); });
    if (progress < 1) this.frame = requestAnimationFrame(tick);
   };
   this.frame = requestAnimationFrame(tick);
  }
  disconnectedCallback() { this.observer?.disconnect(); if (this.frame) cancelAnimationFrame(this.frame); }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dg-floating-cta"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dg-floating-cta')) {
 customElements.define('dg-floating-cta', class extends HTMLElement {
  connectedCallback() {
   this.initFrame = requestAnimationFrame(() => this.init());
  }
  init() {
   if (!this.isConnected || this.bar) return;
   this.bar = this.querySelector('.dgf-bar');
   if (!this.bar) return;
   this.bar.style.cssText = this.style.cssText;
   this.bar.style.fontFamily = getComputedStyle(this).fontFamily;
   document.body.appendChild(this.bar);
   this.mobile = window.matchMedia('(max-width: 749px)');
   this.desktopThreshold = Number(this.dataset.threshold) || 400;
   this.downOnly = this.dataset.direction === 'true';
   this.anchorY = Math.max(0, window.scrollY);
   this.onScroll = () => {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
     this.frame = null;
     const y = Math.max(0, window.scrollY);
     const threshold = this.mobile.matches ? 1 : this.desktopThreshold;
     const delta = y - this.anchorY;
     if (y <= threshold) { this.setVisible(false); this.anchorY = y; }
     else if (!this.downOnly) { this.setVisible(true); this.anchorY = y; }
     else if (delta > 0) { this.setVisible(true); this.anchorY = y; }
     else if (delta < -12 && !this.bar.contains(document.activeElement)) { this.setVisible(false); this.anchorY = y; }
    });
   };
   window.addEventListener('scroll', this.onScroll, { passive: true });
   window.addEventListener('resize', this.onScroll, { passive: true });
   window.addEventListener('pageshow', this.onScroll);
   if (window.scrollY > (this.mobile.matches ? 1 : this.desktopThreshold)) this.setVisible(true);
  }
  setVisible(show) { this.bar.classList.toggle('is-visible', show); this.bar.inert = !show; }
  disconnectedCallback() {
   cancelAnimationFrame(this.initFrame);
   if (this.frame) cancelAnimationFrame(this.frame);
   window.removeEventListener('scroll', this.onScroll);
   window.removeEventListener('resize', this.onScroll);
   window.removeEventListener('pageshow', this.onScroll);
   this.bar?.remove();
   this.bar = null;
  }
 });
}

  } catch(e) { console.error(e); }
})();
})();
